import {
  Box,
  SpaceBetween,
  Form,
  Container,
  Header,
  TextContent,
  Button,
  Modal,
  Grid,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import { useGetMerchantDetailDataQuery } from "../../features/api";
import { useEffect } from "react";
import { PERMISSIONS } from "../../configs/constants";
import { useHasAuthorityHook } from "../../app/useHasAuthorityHook";
// import { useNavigate } from "react-router-dom";
import { COMMON_LABELS, merchantTypePattern } from "../default-constants";
import { changeStyle } from "../../utils/format";
import { getDisplaySales } from "./util";

interface IInfoModal {
  visible: boolean;
  closeDetailModal: Function;
  propsCompanyCode: string;
  propsSiteId: string;
}

const InfoModal = (props: IInfoModal) => {
  const { visible, closeDetailModal, propsSiteId } = props;
  const { data: merchantDetailData, refetch } = useGetMerchantDetailDataQuery({
    cpid: propsSiteId,
  });
  const rateRead = useHasAuthorityHook(PERMISSIONS.RATE_READ);
  const isDocomoController = useHasAuthorityHook(
    PERMISSIONS.APPLY_MERCHANT_DIRECT
  );
  // const navigator = useNavigate();
  const isCommercialFacility =
    merchantDetailData?.typeName ===
    merchantTypePattern.commercialFacility.label;

  useEffect(() => {
    refetch();
  }, [refetch]);

  /**
   * モーダルを閉じる
   */
  const handlerOnDismiss = () => {
    closeDetailModal();
  };

  /**
   * 加盟店情報申請画面に遷移する
   */
  // const toRateUpdate = () => {
  //   navigator("/merchant/rate-update/" + propsCompanyCode, {
  //     state: {
  //       tradeName: merchantDetailData!.tradeName,
  //       merchantDivisionIdentifier:
  //         merchantDetailData!.merchantDivisionIdentifier,
  //       gwCompanyName: merchantDetailData!.gwCompanyName,
  //       rate: merchantDetailData!.rate,
  //       companyCode: propsCompanyCode,
  //       contractNo: merchantDetailData!.contractNo,
  //     },
  //   });
  // };

  //戻るボタン押下時のダイアログ
  // const changeInfoDetailButton = () => {
  //   //TODO:SP16スコープ外
  // };

  return (
    <>
      {merchantDetailData && (
        <Modal
          onDismiss={handlerOnDismiss}
          visible={visible}
          size={"large"}
          footer={
            <>
              <Box float={"left"}>
                <Button
                  formAction={"none"}
                  variant={"link"}
                  onClick={handlerOnDismiss}
                >
                  {LABELS.CLOSE}
                </Button>
              </Box>
              {/* step1　不要 */}
              {/* {isDocomoController ? (
                <Box float={"right"}>
                  <SpaceBetween direction={"horizontal"} size={"xxl"}>
                    <Button
                      formAction={"none"}
                      variant={"link"}
                      onClick={toRateUpdate}
                    >
                      {LABELS.BUTTON_LABEL_RATE}
                    </Button>
                    <Button
                      formAction={"none"}
                      variant={"link"}
                      onClick={changeInfoDetailButton}
                    >
                      {LABELS.BUTTON_LABEL_CHANGE_DETAIL}
                    </Button>
                  </SpaceBetween>
                </Box>
              ) : (
                <></>
              )} */}
            </>
          }
          header={LABELS.MODAL_TITLE}
        >
          <form onSubmit={(e) => e.preventDefault()}>
            <Form>
              <SpaceBetween direction={"vertical"} size={"l"}>
                {merchantDetailData.changedFlag && (
                  <>
                    <Box float={"left"} />
                    <Box float={"right"}>
                      <SpaceBetween direction={"horizontal"} size={"xxl"}>
                        <TextContent>
                          <h4>{LABELS.CHANGED_APP}</h4>
                        </TextContent>
                        {merchantDetailData.orderAdaptationDate && (
                          <>
                            <TextContent>
                              <h4>
                                {`${COMMON_LABELS.LEFT_PARENTHESIS}${LABELS.ADAPTED_DAY}`}
                              </h4>
                            </TextContent>
                            <TextContent>
                              <p>
                                {`${merchantDetailData.orderAdaptationDate}${COMMON_LABELS.RIGHT_PARENTHESIS}`}
                              </p>
                            </TextContent>
                          </>
                        )}
                      </SpaceBetween>
                    </Box>
                  </>
                )}
                <Container>
                  <SpaceBetween direction="vertical" size="xxs">
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>
                            {LABELS.MERCHANT_NAME + LABELS.BLANK_SPACE_FIVE}
                          </h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {(merchantDetailData.tradeNameKana ??
                              LABELS.BLANK_SPACE_ONE) +
                              LABELS.SLASH +
                              (merchantDetailData.tradeNameAlphabetical ??
                                LABELS.BLANK_SPACE_ONE)}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.BLANK_SPACE_ONE}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.tradeName ??
                              LABELS.BLANK_SPACE_ONE}
                            {merchantDetailData.merchantDivisionIdentifier
                              ? `${COMMON_LABELS.LEFT_PARENTHESIS}${merchantDetailData.merchantDivisionIdentifier}${COMMON_LABELS.RIGHT_PARENTHESIS}`
                              : COMMON_LABELS.BLANK}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.STATUS}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>{merchantDetailData.contractStatus}</p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                  </SpaceBetween>
                </Container>
                <Container
                  header={
                    <Header variant={"h2"}>{LABELS.MERCHANT_TITLE}</Header>
                  }
                >
                  <SpaceBetween direction="vertical" size="xxs">
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.MERCHANT_NAME}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.tradeName ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.MERCHANT_TYPE}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.typeName ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    {isCommercialFacility ? (
                      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.STORE_ADDRESS}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>
                              {merchantDetailData.commercialFacilityAddressNo
                                ? changeStyle(
                                    merchantDetailData.commercialFacilityAddressNo ??
                                      ""
                                  )
                                : LABELS.BLANK_SPACE_ONE}
                            </p>
                          </TextContent>
                        </SpaceBetween>
                      </Grid>
                    ) : (
                      <></>
                    )}

                    {isCommercialFacility ? (
                      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.BLANK_SPACE_ONE}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>
                              {merchantDetailData.commercialFacilityAddressKana ??
                                LABELS.BLANK_SPACE_ONE}
                            </p>
                          </TextContent>
                        </SpaceBetween>
                      </Grid>
                    ) : (
                      <></>
                    )}

                    {isCommercialFacility ? (
                      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.BLANK_SPACE_ONE}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>
                              {merchantDetailData.commercialFacilityAddress ??
                                LABELS.BLANK_SPACE_ONE}
                            </p>
                          </TextContent>
                        </SpaceBetween>
                      </Grid>
                    ) : (
                      <></>
                    )}

                    {isCommercialFacility ? (
                      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.COMMERCIAL_FACILITY_PHONE_NUMBER}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>
                              {merchantDetailData.commercialFacilityPhoneNumber ??
                                LABELS.BLANK_SPACE_ONE}
                            </p>
                          </TextContent>
                        </SpaceBetween>
                      </Grid>
                    ) : (
                      <></>
                    )}

                    {isDocomoController ? (
                      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.EARNING}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>
                              {getDisplaySales(
                                merchantDetailData.sales,
                                merchantDetailData.nowDate
                              )}
                            </p>
                          </TextContent>
                        </SpaceBetween>
                      </Grid>
                    ) : (
                      <></>
                    )}

                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.INDUSTRY}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.industry ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.INDUSTRY_COMMENT}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.industryComment ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.IPID}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.ipId ?? LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.SITE_ID}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.siteId ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    {isDocomoController ? (
                      <Grid
                        gridDefinition={[
                          { colspan: 3 },
                          { colspan: 3 },
                          { colspan: 3 },
                          { colspan: 3 },
                        ]}
                      >
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.SETTLEMENT_GROUP_ID}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>
                              {merchantDetailData.settlementGroupId ??
                                LABELS.BLANK_SPACE_ONE}
                            </p>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.ACCESS_KEY}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>
                              {merchantDetailData.accessKey ??
                                LABELS.BLANK_SPACE_ONE}
                            </p>
                          </TextContent>
                        </SpaceBetween>
                      </Grid>
                    ) : (
                      <></>
                    )}
                    {isDocomoController ? (
                      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.SECRET_KEY}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>
                              {merchantDetailData.secretKey ??
                                LABELS.BLANK_SPACE_ONE}
                            </p>
                          </TextContent>
                        </SpaceBetween>
                      </Grid>
                    ) : (
                      <></>
                    )}
                    {isDocomoController ? (
                      <Grid
                        gridDefinition={[
                          { colspan: 3 },
                          { colspan: 3 },
                          { colspan: 3 },
                          { colspan: 3 },
                        ]}
                      >
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.SHOP_ID}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>
                              {merchantDetailData.shopId ??
                                LABELS.BLANK_SPACE_ONE}
                            </p>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.SHOP_PW}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>
                              {merchantDetailData.shopIdPassword ??
                                LABELS.BLANK_SPACE_ONE}
                            </p>
                          </TextContent>
                        </SpaceBetween>
                      </Grid>
                    ) : (
                      <></>
                    )}
                    {isDocomoController ? (
                      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.TERMINAL_IDENTIFICATION_NUMBER}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>
                              {merchantDetailData.terminalIdentificationNumber ??
                                LABELS.BLANK_SPACE_ONE}
                            </p>
                          </TextContent>
                        </SpaceBetween>
                      </Grid>
                    ) : (
                      <></>
                    )}
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.MERCHANT_ID}</h4>
                          <h4>{LABELS.MERCHANT_LABEL}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.comprehensiveMerchantCode ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                  </SpaceBetween>
                </Container>
                <Container
                  header={
                    <Header variant={"h2"}>{LABELS.CONTRACT_TITLE}</Header>
                  }
                >
                  <SpaceBetween direction="vertical" size="xxs">
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.SERVICE}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.contractService ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.CONTRACT_ROUTE}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.contractRoute ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.CHARGE}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.payingType ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>
                            {LABELS.PAYMENT_METHOD + LABELS.BLANK_SPACE_TWO}
                          </h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.qrPaymentSystem ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    {rateRead ? (
                      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <h4>{LABELS.RATE}</h4>
                          </TextContent>
                        </SpaceBetween>
                        <SpaceBetween direction="vertical" size="xxs">
                          <TextContent>
                            <p>{merchantDetailData.rate + "%"}</p>
                          </TextContent>
                        </SpaceBetween>
                      </Grid>
                    ) : (
                      <></>
                    )}
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.GW}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.gwCompanyName ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                  </SpaceBetween>
                </Container>
                <Container
                  header={<Header variant="h2">{LABELS.STATUS}</Header>}
                >
                  <SpaceBetween direction="vertical" size="xxs">
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.STATUS}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>{merchantDetailData.contractStatus}</p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                    <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <h4>{LABELS.TERMINATION_DATE}</h4>
                          <h4>{LABELS.TERMINATION_LABEL}</h4>
                        </TextContent>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <TextContent>
                          <p>
                            {merchantDetailData.endDateTime ??
                              LABELS.BLANK_SPACE_ONE}
                          </p>
                        </TextContent>
                      </SpaceBetween>
                    </Grid>
                  </SpaceBetween>
                </Container>
              </SpaceBetween>
            </Form>
          </form>
        </Modal>
      )}
    </>
  );
};
export default InfoModal;
